import { useEffect, useState } from "react";

interface ResponsiveState {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
}

export const useResponsive = (): ResponsiveState => {
  const [state, setState] = useState<ResponsiveState>({
    isMobile: false,
    isTablet: false,
    isDesktop: true,
  });

  useEffect(() => {
    const checkDevice = () => {
      const width = window.innerWidth;

      const isMobile = width < 768; // Tailwind md breakpoint
      const isTablet = width >= 768 && width < 1024; // Tailwind lg breakpoint
      const isDesktop = width >= 1024;

      setState({
        isMobile,
        isTablet,
        isDesktop,
      });
    };

    // 初回実行
    checkDevice();

    // リサイズイベントリスナー
    window.addEventListener("resize", checkDevice);

    return () => {
      window.removeEventListener("resize", checkDevice);
    };
  }, []);

  return state;
};
